/* eslint-disable jsx-a11y/accessible-emoji */
import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import { FaSlack } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { getInviteLink, updateProfile } from '../../../redux/MainAction';
import moment from 'moment-timezone';
import { getInviteRegisterUrl } from '../../../Constant';
import { toast } from 'react-toastify';
import Select from 'react-select';

const AdminSteps = () => {
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(1);
  const link = useSelector((state) => state.Webtracker?.inviteLink);
  const [emails, setEmails] = useState('');

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    dispatch(getInviteLink());
  };

  const [selectedTimeZone, setSelectedTimeZone] = useState('');

  // Fetch all time zone names
  const timeZones = moment.tz.names();

  const getTimeZoneOptions = () => {
    return timeZones.map((zone) => {
      const offset = moment.tz(zone).utcOffset() / 60;
      const formattedOffset = `(UTC${offset >= 0 ? '+' : ''}${offset})`;
      const displayName = `${formattedOffset} ${zone}`;
      return {
        value: displayName,
        label: displayName,
      };
    });
  };

  const timeZoneOptions = getTimeZoneOptions();

  const handleChange = (val) => {
    setSelectedTimeZone(val);
  };

  const FulName = localStorage.getItem('ad_name');

  const [switch1, setSwitch1] = useState(true);
  const [switch2, setSwitch2] = useState(false);
  const [switch3, setSwitch3] = useState(true);
  const [switch4, setSwitch4] = useState(false);

  const [profileData, setProfileData] = useState({
    industry: '',
    role: '',
    goal: '',
    preferredDesktopApp: false,
    preferredMobileApp: false,
    preferredDirectEntry: false,
    preferredBrowserTimeTracker: false,
    workspaceName: '',
    timezone: '',
    workArrangement: '',
    people: '',
    mobile: '',
  });

  const onChnageHandle = (e) => {
    const { name, value } = e.target;
    setProfileData({ ...profileData, [name]: value });
  };

  const handleCopy = () => {
    const linkValue = `${getInviteRegisterUrl()}/${link?.joiningToken}`;
    navigator.clipboard
      .writeText(linkValue) // Use Clipboard API
      .then(() => {
        alert('Link copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy the text: ', err);
      });
  };

  const handleSwitchChange = () => {
    setSwitch1(!switch1);
  };
  const handleSwitchChange2 = () => {
    setSwitch2(!switch2);
  };
  const handleSwitchChange3 = () => {
    setSwitch3(!switch3);
  };
  const handleSwitchChange4 = () => {
    setSwitch4(!switch4);
  };

  const nextStep = () => {
    if (currentStep < 7) {
      if (currentStep === 1 && !profileData.workspaceName) {
        toast.error('Workspace Name is mandatory !', {
          position: 'top-center',
        });
        return;
      }

      if (currentStep === 2 && !selectedTimeZone) {
        toast.error('Timezone is mandatory!', {
          position: 'top-center',
        });
        return;
      }

      if (currentStep === 5 && !profileData.mobile) {
        toast.error('Mobile number is mandatory!', {
          position: 'top-center',
        });
        return;
      }

      setCurrentStep(currentStep + 1);
    }
  };
  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const emailsArray = emails
      .split(',')
      .map((email) => email.trim())
      .filter((email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      ?.map((email) => ({ email, role: 'EMPLOYEE' }));

    const payload = {
      ...(profileData?.industry ? { industry: profileData?.industry } : {}),
      ...(profileData?.role ? { role: profileData?.role } : {}),
      ...(profileData?.goal ? { goal: profileData?.goal } : {}),
      ...(profileData?.workArrangement
        ? { workArrangement: profileData?.workArrangement }
        : {}),
      preferredDesktopApp: switch1,
      preferredMobileApp: switch2,
      preferredDirectEntry: switch3,
      preferredBrowserTimeTracker: switch4,
      workspaceName: profileData?.workspaceName,
      timezone: selectedTimeZone,
      mobile: profileData?.mobile,
    };
    dispatch(updateProfile(payload, { members: emailsArray }));
  };

  return (
    <AUX>
      <div
        className="accountbg"
        style={{
          background: "url('assets/images/stardust.png')",
          backgroundSize: 'cover',
        }}
      ></div>
      <div className="wrapper-page page_width">
        <div className="card" style={{ width: '800px' }}>
          <div className="card-body">
            <div className="stepper-wrapper">
              <div
                className={
                  currentStep === 1 ? 'stepper-item' : 'stepper-item completed'
                }
              >
                <div className="step-counter"></div>
                <div className="step-name"></div>
              </div>
              <div
                className={
                  currentStep > 2 ? 'stepper-item completed' : 'stepper-item '
                }
              >
                <div className="step-counter"></div>
                <div className="step-name"></div>
              </div>
              <div
                className={
                  currentStep > 3 ? 'stepper-item completed' : 'stepper-item '
                }
              >
                <div className="step-counter"></div>
                <div className="step-name"></div>
              </div>
              <div
                className={
                  currentStep > 4 ? 'stepper-item completed' : 'stepper-item '
                }
              >
                <div className="step-counter"></div>
                <div className="step-name"></div>
              </div>
              <div
                className={
                  currentStep > 5 ? 'stepper-item completed' : 'stepper-item '
                }
              >
                <div className="step-counter"></div>
                <div className="step-name"></div>
              </div>
              <div
                className={
                  currentStep > 6 ? 'stepper-item completed' : 'stepper-item '
                }
              >
                <div className="step-counter"></div>
                <div className="step-name"></div>
              </div>
            </div>
            <div className="stepper-content">
              {currentStep === 1 && (
                <div className="step1">
                  <h3>Welcome {FulName}👋</h3>
                  <h4 className="text-muted">Let’s create your workspace</h4>
                  <div className="d-flex flex-column mt-5">
                    <label className="d-flex align-items-center">
                      What would you like to call your workspace?{' '}
                      <p className="text-danger">*</p>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Your Workspace name"
                      name="workspaceName"
                      value={profileData?.workspaceName}
                      onChange={onChnageHandle}
                      style={{ maxWidth: '400px' }}
                    />
                  </div>
                </div>
              )}
              {currentStep === 2 && (
                <div className="step2">
                  <div className="d-flex flex-column" style={{ gap: '10px' }}>
                    <label className="d-flex align-items-center label_font">
                      Which timezone works best for your team ?{' '}
                      <span className="text-danger">*</span>
                    </label>
                    <div>
                      <Select
                        value={timeZoneOptions.find(
                          (option) => option.value === selectedTimeZone
                        )}
                        onChange={(selectedOption) =>
                          handleChange(selectedOption.value)
                        }
                        options={timeZoneOptions}
                        placeholder="Select a Time Zone"
                        styles={{
                          container: (base) => ({ ...base, maxWidth: '400px' }),
                        }}
                      />
                    </div>
                    <label className="d-flex align-items-center label_font mt-5">
                      What is the primary work arrangement for your team ?
                    </label>
                    <div className="d-flex " style={{ gap: '20px' }}>
                      <div
                        className={
                          profileData?.workArrangement === 'Remote'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="age1"
                          name="workArrangement"
                          checked={profileData?.workArrangement === 'Remote'}
                          value={'Remote'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="age1">Remote</label>
                      </div>
                      <div
                        className={
                          profileData?.workArrangement === 'Hybrid'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="Hybrid"
                          name="workArrangement"
                          checked={profileData?.workArrangement === 'Hybrid'}
                          value={'Hybrid'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="Hybrid">Hybrid</label>
                      </div>
                      <div
                        className={
                          profileData?.workArrangement === 'Office-based'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="Office"
                          name="workArrangement"
                          checked={
                            profileData?.workArrangement === 'Office-based'
                          }
                          value={'Office-based'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="Office">Office-based</label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentStep === 3 && (
                <div className="step3">
                  <div className="d-flex flex-column mt-5">
                    <label className="d-flex align-items-center label_font">
                      What is your main goal with WebTracker?
                    </label>
                    <div className="radio_main">
                      <div
                        className={
                          profileData?.goal === 'Monitor work time and activity'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="act"
                          name="goal"
                          checked={
                            profileData?.goal ===
                            'Monitor work time and activity'
                          }
                          value={'Monitor work time and activity'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="act">
                          Monitor work time and activity
                        </label>
                      </div>
                      <div
                        className={
                          profileData?.goal === 'Manage attendance and time-off'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="Hyb"
                          name="goal"
                          checked={
                            profileData?.goal ===
                            'Manage attendance and time-off'
                          }
                          value={'Manage attendance and time-off'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="Hyb">
                          Manage attendance and time-off
                        </label>
                      </div>
                      <div
                        className={
                          profileData?.goal === 'Manage tasks and projects'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="Offe"
                          name="goal"
                          checked={
                            profileData?.goal === 'Manage tasks and projects'
                          }
                          value={'Manage tasks and projects'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="Offe">Manage tasks and projects</label>
                      </div>
                      <div
                        className={
                          profileData?.goal ===
                          'Review and approving timesheets'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="Of"
                          name="goal"
                          checked={
                            profileData?.goal ===
                            'Review and approving timesheets'
                          }
                          value={'Review and approving timesheets'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="Of">
                          Review and approving timesheets
                        </label>
                      </div>
                      <div
                        className={
                          profileData?.goal ===
                          'Monitor and assess employee productivity'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="prod"
                          name="goal"
                          checked={
                            profileData?.goal ===
                            'Monitor and assess employee productivity'
                          }
                          value={'Monitor and assess employee productivity'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="prod">
                          Monitor and assess employee productivity
                        </label>
                      </div>
                      <div
                        className={
                          profileData?.goal ===
                          'Ensure work-life balance of employees'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="life"
                          name="goal"
                          checked={
                            profileData?.goal ===
                            'Ensure work-life balance of employees'
                          }
                          value={'Ensure work-life balance of employees'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="life">
                          Ensure work-life balance of employees
                        </label>
                      </div>
                      <div
                        className={
                          profileData?.goal === 'Paying employees'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="emp"
                          name="goal"
                          checked={profileData?.goal === 'Paying employees'}
                          value={'Paying employees'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="emp">Paying employees</label>
                      </div>
                      <div
                        className={
                          profileData?.goal === 'Generating invoices'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="gen"
                          name="goal"
                          checked={profileData?.goal === 'Generating invoices'}
                          value={'Generating invoices'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="gen">Generating invoices</label>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentStep === 4 && (
                <div className="step3">
                  <div className="d-flex flex-column mt-5">
                    <label className="d-flex align-items-center label_font">
                      How many people will you be working with?
                    </label>
                    <div className="radio_main" style={{ width: '400px' }}>
                      <div
                        className={
                          profileData.people === 'Just me'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="me"
                          name="people"
                          checked={profileData.people === 'Just me'}
                          value={'Just me'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="me">Just me</label>
                      </div>
                      <div
                        className={
                          profileData.people === '2-5'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="2"
                          name="people"
                          checked={profileData.people === '2-5'}
                          value={'2-5'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="2">2-5</label>
                      </div>
                      <div
                        className={
                          profileData.people === '6-10'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="6"
                          name="people"
                          checked={profileData.people === '6-10'}
                          value={'6-10'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="6">6-10</label>
                      </div>
                      <div
                        className={
                          profileData.people === '11-25'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="11"
                          name="people"
                          checked={profileData.people === '11-25'}
                          value={'11-25'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="11">11-25</label>
                      </div>
                      <div
                        className={
                          profileData.people === '26-100'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="26"
                          name="people"
                          checked={profileData.people === '26-100'}
                          value={'26-100'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="26">26-100</label>
                      </div>
                      <div
                        className={
                          profileData.people === '101-500'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="101"
                          name="people"
                          checked={profileData.people === '101-500'}
                          value={'101-500'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="101">101-500</label>
                      </div>
                      <div
                        className={
                          profileData.people === '500'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="500"
                          name="people"
                          checked={profileData.people === '500'}
                          value={'500'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="500">500+</label>
                      </div>
                    </div>
                    <div className="label_font mt-5">
                      <label className="label_font">
                        What’s your industry ?
                      </label>
                      <select
                        className="form-control"
                        name="industry"
                        value={profileData?.industry}
                        onChange={onChnageHandle}
                        style={{ maxWidth: '400px' }}
                      >
                        <option>Select industry</option>
                        <option value="Web & software development">
                          {' '}
                          Web & software development
                        </option>
                        <option value="Product development">
                          Product development
                        </option>
                        <option value="Education & training">
                          Education & training
                        </option>
                        <option value="Tecknology">Tecknology</option>
                        <option value="Hospitality">Hospitality</option>
                        <option value="Healthcare">Healthcare</option>
                        <option value="Marketing & advertising">
                          Marketing & advertising
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              )}
              {currentStep === 5 && (
                <div className="step3">
                  <div className="d-flex flex-column mt-5">
                    <label className="d-flex align-items-center label_font">
                      What is your primary role?
                    </label>
                    <div className="radio_main">
                      <div
                        className={
                          profileData.role === 'Executive/CEO'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="co"
                          name="role"
                          checked={profileData.role === 'Executive/CEO'}
                          value={'Executive/CEO'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="co">Executive/CEO</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Manager/Supervisor'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="vise"
                          name="role"
                          checked={profileData.role === 'Manager/Supervisor'}
                          value={'Manager/Supervisor'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="vise">Manager/Supervisor</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Project Manager'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="ject"
                          name="role"
                          checked={profileData.role === 'Project Manager'}
                          value={'Project Manager'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="ject">Project Manager</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Technical Lead'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="13"
                          name="role"
                          checked={profileData.role === 'Technical Lead'}
                          value={'Technical Lead'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="13">Technical Lead</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Product Manager'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="24"
                          name="role"
                          checked={profileData.role === 'Product Manager'}
                          value={'Product Manager'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="24">Product Manager</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Marketing Manager'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="1021"
                          name="role"
                          checked={profileData.role === 'Marketing Manager'}
                          value={'Marketing Manager'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="1021">Marketing Manager</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Team Lead'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="500"
                          name="role"
                          checked={profileData.role === 'Team Lead'}
                          value={'Team Lead'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="500">Team Lead</label>
                      </div>
                      <div
                        className={
                          profileData.role === 'Creative Director'
                            ? 'radio_button radio_active'
                            : 'radio_button'
                        }
                      >
                        <input
                          type="radio"
                          id="50"
                          name="role"
                          checked={profileData.role === 'Creative Director'}
                          value={'Creative Director'}
                          onChange={onChnageHandle}
                        />
                        <label htmlFor="50">Creative Director</label>
                      </div>
                    </div>
                    <div className="label_font mt-5">
                      <label className="label_font">
                        Please provide your phone number
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Your phone no"
                        name="mobile"
                        value={profileData?.mobile}
                        onChange={onChnageHandle}
                        style={{ maxWidth: '400px' }}
                      />
                    </div>
                  </div>
                </div>
              )}
              {currentStep === 6 && (
                <div className="step4 mt-4">
                  <div className="d-flex flex-column">
                    <span className="d-flex align-items-center label_font">
                      How do you prefer to track time with your team?
                    </span>
                    <span className="font-14 subheading">
                      You can change these settings later in your workspace.
                    </span>
                    <div
                      className="team_content d-flex flex-column mt-3"
                      style={{ maxWidth: '600px', gap: '10px' }}
                    >
                      <div
                        className="border d-flex justify-content-start"
                        style={{ borderRadius: '4px', maxHeight: '78px' }}
                      >
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ minWidth: '100px' }}
                        >
                          <i className="mbri-desktop team_icons"></i>
                        </div>
                        <div
                          className="d-flex flex-column justify-content-start p-1"
                          style={{ minWidth: '395px' }}
                        >
                          <span className="14" style={{ fontWeight: '600' }}>
                            Desktop App
                          </span>
                          <span
                            className="font-14"
                            style={{ fontWeight: '200' }}
                          >
                            For comprehensive time tracking including
                            screenshots,
                            <br /> activity level, app & web usage.
                          </span>
                        </div>
                        <div className="d-flex flex-column">
                          <span className="rcomend">Recommended</span>
                          <div className="toggle-switch mt-2 ml-4">
                            <input
                              type="checkbox"
                              id="switch"
                              className="toggle-input"
                              checked={switch1}
                              onChange={handleSwitchChange}
                            />
                            <label
                              className="toggle-label"
                              htmlFor="switch"
                            ></label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border d-flex justify-content-start"
                        style={{ borderRadius: '4px', maxHeight: '78px' }}
                      >
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ minWidth: '100px' }}
                        >
                          <i className="mbri-mobile team_icons2"></i>
                        </div>
                        <div
                          className="d-flex flex-column justify-content-start p-1"
                          style={{ minWidth: '395px' }}
                        >
                          <span className="14" style={{ fontWeight: '600' }}>
                            Mobile App
                          </span>
                          <span
                            className="font-14"
                            style={{ fontWeight: '200' }}
                          >
                            For tracking time and employee geolocation via the
                            <br /> smartphone app.
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                          <div className="toggle-switch mt-2 ml-4">
                            <input
                              type="checkbox"
                              id="switch2"
                              className="toggle-input"
                              checked={switch2}
                              onChange={handleSwitchChange2}
                            />
                            <label
                              className="toggle-label"
                              htmlFor="switch2"
                            ></label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border d-flex justify-content-start"
                        style={{ borderRadius: '4px', height: '78px' }}
                      >
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ minWidth: '100px' }}
                        >
                          <i className="mbri-edit team_icons3"></i>
                        </div>
                        <div
                          className="d-flex flex-column justify-content-start p-1 mt-2"
                          style={{ minWidth: '395px' }}
                        >
                          <span className="14" style={{ fontWeight: '600' }}>
                            Direct Entry
                          </span>
                          <span
                            className="font-14"
                            style={{ fontWeight: '200' }}
                          >
                            For inputting work hours into the timesheet
                            directly.
                          </span>
                        </div>
                        <div className="d-flex align-items-center justify-content-center">
                          <div className=" toggle-switch mt-2 ml-4">
                            <input
                              type="checkbox"
                              id="switch3"
                              className="toggle-input"
                              checked={switch3}
                              onChange={handleSwitchChange3}
                            />
                            <label
                              className="toggle-label"
                              htmlFor="switch3"
                            ></label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="border d-flex justify-content-start"
                        style={{ borderRadius: '4px', maxHeight: '78px' }}
                      >
                        <div
                          className="d-flex justify-content-center align-items-center"
                          style={{ minWidth: '100px' }}
                        >
                          <i className="mbri-browse team_icons4"></i>
                        </div>
                        <div
                          className="d-flex flex-column justify-content-start p-1"
                          style={{ minWidth: '200px' }}
                        >
                          <span className="14" style={{ fontWeight: '600' }}>
                            Browser Time Tracker
                          </span>
                          <span
                            className="font-14"
                            style={{ fontWeight: '200' }}
                          >
                            Just for time tracking in your dashboard or through
                            the
                            <br />
                            chrome extension, without activity monitoring or
                            screenshots.
                          </span>
                        </div>
                        <div className="d-flex flex-column">
                          <span className="rcomend2">Without monitoring</span>
                          <div className="toggle-switch mt-2 ml-5">
                            <input
                              type="checkbox"
                              id="switch4"
                              className="toggle-input"
                              checked={switch4}
                              onChange={handleSwitchChange4}
                            />
                            <label
                              className="toggle-label"
                              htmlFor="switch4"
                            ></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {currentStep === 7 && (
                <div className="step3">
                  <div className="d-flex flex-column">
                    <label className=" label_font">
                      Copy the following link to invite members to your
                      workspace
                    </label>
                    <div className="d-flex" style={{ gap: '10px' }}>
                      <input
                        type="text"
                        value={`${getInviteRegisterUrl()}/${link?.joiningToken}`}
                        className="form-control"
                        readOnly
                      />
                      <Button
                        size="sm"
                        color="dark"
                        style={{ width: '120px' }}
                        onClick={handleCopy}
                      >
                        <i className="mdi mdi-content-copy"></i> Copy
                      </Button>
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <label className="label_font">
                        Invite members to your workspace with email
                      </label>
                      <input
                        type="emails"
                        className="form-control"
                        placeholder="Eg.joe@gmail.com, doe@gmail.com - Comma Separated Values"
                        value={emails}
                        onChange={(e) => setEmails(e.target.value)}
                      />
                    </div>
                    <div className="d-flex flex-column mt-3">
                      <label className="label_font">
                        Invite members from these
                      </label>
                      <Button outline color="dark">
                        <FaSlack /> Slack
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              <div
                className={
                  currentStep === 1
                    ? 'd-flex justify-content-end '
                    : 'd-flex justify-content-between '
                }
              >
                {currentStep > 1 && (
                  <Button
                    outline
                    color="primary"
                    size="sm"
                    style={{ width: '100px' }}
                    onClick={prevStep}
                  >
                    Back
                  </Button>
                )}
                {currentStep === 7 ? (
                  <Button
                    outline
                    color="primary"
                    size="sm"
                    style={{ width: '150px' }}
                    onClick={onSubmit}
                  >
                    Go to the Dashboard
                  </Button>
                ) : (
                  <Button
                    outline
                    color="primary"
                    size="sm"
                    style={{ width: '100px' }}
                    onClick={nextStep}
                  >
                    Next
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default AdminSteps;
